function quadraticYOnX(d) {
  d.sort(function (c, a) {
    return parseFloat(c.x) - parseFloat(a.x);
  });
  var g,
      h,
      i,
      j,
      k,
      p,
      s,
      A,
      B,
      C,
      D = [],
      x = [],
      y = 0,
      E = 0,
      F = d.length,
      G = 0,
      H = 0,
      I = 0,
      J = 0,
      K = 0,
      L = [];

  for (var a = 0; a < d.length; a++) {
    (B = +d[a].x, C = +d[a].y, !(isNaN(B) || isNaN(C))) && (D.push(B), x.push(C));
  }

  F = D.length;

  for (var _a = 0; _a < F; _a++) {
    y += x[_a], E += D[_a] * x[_a], K += D[_a] * D[_a] * x[_a], G += D[_a], H += D[_a] * D[_a], J += D[_a] * D[_a] * D[_a], I += D[_a] * D[_a] * D[_a] * D[_a];
  }

  if (g = H - G * G / F, h = E - G * y / F, i = J - H * G / F, j = K - H * y / F, k = I - H * H / F, 0 == g * k - i * i || 0 === F) return [d, []];
  p = (j * g - h * i) / (g * k - i * i), s = (h * k - j * i) / (g * k - i * i), A = y / F - s * (G / F) - p * (H / F);

  for (var _a2 = 0; _a2 < F; _a2++) {
    L.push({
      x: D[_a2],
      y: p * D[_a2] * D[_a2] + s * D[_a2] + A
    });
  }

  return [d, L];
}

function quadraticXOnY(d) {
  d.sort(function (c, a) {
    return parseFloat(c.x) - parseFloat(a.x);
  });
  var g,
      h,
      i,
      j,
      k,
      p,
      s,
      A,
      B,
      C,
      D = [],
      x = [],
      y = 0,
      E = 0,
      F = d.length,
      G = 0,
      H = 0,
      I = 0,
      J = 0,
      K = 0,
      L = [];

  for (var a = 0; a < d.length; a++) {
    (B = +d[a].x, C = +d[a].y, !(isNaN(B) || isNaN(C))) && (D.push(B), x.push(C));
  }

  F = D.length;

  for (var _a3 = 0; _a3 < F; _a3++) {
    y += D[_a3], E += x[_a3] * D[_a3], K += x[_a3] * x[_a3] * D[_a3], G += x[_a3], H += x[_a3] * x[_a3], J += x[_a3] * x[_a3] * x[_a3], I += x[_a3] * x[_a3] * x[_a3] * x[_a3];
  }

  if (g = H - G * G / F, h = E - G * y / F, i = J - H * G / F, j = K - H * y / F, k = I - H * H / F, 0 == g * k - i * i || 0 === F) return [d, []];
  p = (j * g - h * i) / (g * k - i * i), s = (h * k - j * i) / (g * k - i * i), A = y / F - s * (G / F) - p * (H / F);

  for (var _a4 = 0; _a4 < F; _a4++) {
    L.push({
      x: p * x[_a4] * x[_a4] + s * x[_a4] + A,
      y: x[_a4]
    });
  }

  return [d, L];
}

export default function getPolynomialRegressionPoints(a, b) {
  return +b ? quadraticYOnX(a) : quadraticXOnY(a);
}